import { Button, Switch, Tooltip } from "antd";
import moment from "moment";
import React from "react";
const ButtonGroup = Button.Group;
export default (countryList, toggleStatus, triggerUpdate) => [
  {
    title: "Email",
    align: "center",
    render: (record) => {
      return (
        <div>
          {record["member_email"]}
          <br></br>
          {record["revision_name"] && (
            <span style={{ fontSize: "12px", color: "rgb(187 187 187)" }}>
              {record["revision_name"]}
            </span>
          )}
        </div>
      );
    },
  },
  {
    title: "Country",
    dataIndex: "country_abbr",
    align: "center",
    render: (text) => {
      let country = "";
      if (text === "NONE" || !text) {
        country = "Default";
      }
      const findCountry = countryList.find((row) => row.region_code === text);

      if (findCountry) {
        country = findCountry["name"];
      }

      return <span style={{ fontWeight: "bold" }}>{country}</span>;
    },
  },
  {
    title: "Create Time",
    dataIndex: "created",
    align: "center",
    render: (date) => {
      if (!date.Valid) {
        return "-";
      }
      const datetime = new Date(date.Time);
      return moment(datetime).format("MMM  DD YYYY LT");
    },
  },
  {
    title: "Original Rate",
    dataIndex: "price_sell",
    align: "center",
    render: (text) => {
      if (!text) {
        return "-";
      }
      return (
        <span style={{ color: "rgb(187 187 187)" }}>{text.toFixed(4)}</span>
      );
    },
  },
  {
    title: "Offer Rate",
    dataIndex: "price",
    align: "center",
    render: (text) => {
      return <span style={{ fontWeight: "bold" }}>{text.toFixed(4)}</span>;
    },
  },
  {
    title: "Expire Date",
    dataIndex: "expired",
    align: "center",
    render: (date) => {
      if (!date.Valid) {
        return "-";
      }
      const datetime = new Date(date.Time);
      return moment(datetime).format("MMM  DD YYYY");
    },
  },
  {
    title: "Last Update",
    dataIndex: "updated",
    align: "center",
    render: (date) => {
      if (!date.Valid) {
        return "-";
      }
      const datetime = new Date(date.Time);
      return moment(datetime).format("MMM  DD YYYY LT");
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    align: "center",
    render: (status, record) => {
      const convStatus = {
        enabled: true,
        disabled: false,
      };

      return (
        <Switch
          checked={convStatus[status]}
          onChange={(e) => toggleStatus(record, status)}
        />
      );
    },
  },
  {
    title: "Action",
    align: "center",
    width: "15%",
    render: (record) => {
      return (
        <div>
          <ButtonGroup>
            <Tooltip placement="top" title="แก้ไข">
              <Button icon="edit" onClick={() => triggerUpdate(record)} />
            </Tooltip>
            <Tooltip placement="top" title="ลบ">
              <Button
                type="danger"
                icon="delete"
                onClick={() => toggleStatus(record, "delete")}
              />
            </Tooltip>
          </ButtonGroup>
        </div>
      );
    },
  },
];



// WEBPACK FOOTER //
// ./src/containers/OfferManagement/column.js